import { tokens } from '@/theme/theme';

export type AppEnvironment = { key: 'local' | 'preprod' | 'prod'; label: string; color: string; bg: string };

/** Environnement déduit du nom d'hôte (badge dans la barre latérale et sur l'écran de connexion). */
export const getEnvironment = (): AppEnvironment => {
  const host = typeof window !== 'undefined' ? window.location.hostname : '';
  if (host === 'localhost' || host === '127.0.0.1' || host.endsWith('.local')) {
    return { key: 'local', label: 'Local', color: tokens.blue, bg: tokens.blueSoft };
  }
  if (host.includes('preprod') || host.includes('staging')) {
    return { key: 'preprod', label: 'Préprod', color: tokens.amber, bg: tokens.amberSoft };
  }
  return { key: 'prod', label: 'Prod', color: tokens.green, bg: tokens.greenSoft };
};
